// ============================================================
// FIT ANATOMY — versione dashboard (/dashboard/fit-anatomy)
// ============================================================

import React, { useEffect, useState } from 'react';
import FitAnatomyGrid from '../../../common/fitAnatomy/FitAnatomyGrid';
import { fitAnatomyService } from '../../../../services/fitAnatomy.service';
import type { FitAnatomyResource } from '../../../../types/course';
import './FitAnatomy.css';

const FitAnatomy: React.FC = () => {
  const [resources, setResources] = useState<FitAnatomyResource[]>([]);
  const [loading, setLoading] = useState(true);
  const authToken = localStorage.getItem('bp_token') ?? '';

  useEffect(() => {
    fitAnatomyService
      .getResources()
      .then(setResources)
      .catch((err) => console.error('[FitAnatomy] Errore:', err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: '40vh' }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Caricamento...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="fa-page">
      <div className="fa-page__header">
        <div>
          <h1 className="fa-page__title">
            <i className="bi bi-heart-pulse me-2" aria-hidden="true" />
            Fit Anatomy
          </h1>
          <p className="fa-page__subtitle">
            Risorse gratuite per il tuo benessere posturale. Scarica, ascolta e
            guarda quando vuoi.
          </p>
        </div>
      </div>
      <FitAnatomyGrid
        resources={resources}
        isAuthenticated={true}
        authToken={authToken}
      />
    </div>
  );
};

export default FitAnatomy;
